import { render, staticRenderFns } from "./CriarGrupo.vue?vue&type=template&id=cad92de2&scoped=true"
import script from "./CriarGrupo.vue?vue&type=script&lang=js"
export * from "./CriarGrupo.vue?vue&type=script&lang=js"
import style0 from "./CriarGrupo.vue?vue&type=style&index=0&id=cad92de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad92de2",
  null
  
)

export default component.exports